// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__19st-","amount":"Amount_amount__3XFzL","tip":"Amount_tip__1VpIT","tipHeader":"Amount_tipHeader__3LyAV","tipsWrap":"Amount_tipsWrap__yIsu5"};